/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RefundMerchantSaleMutationVariables = {
    transferId: string;
};
export type RefundMerchantSaleMutationResponse = {
    readonly refundMerchantSale: {
        readonly transfer: {
            readonly id: string;
        } | null;
    } | null;
};
export type RefundMerchantSaleMutation = {
    readonly response: RefundMerchantSaleMutationResponse;
    readonly variables: RefundMerchantSaleMutationVariables;
};



/*
mutation RefundMerchantSaleMutation(
  $transferId: ID!
) {
  refundMerchantSale(transferId: $transferId) {
    transfer {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transferId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "transferId",
        "variableName": "transferId"
      }
    ],
    "concreteType": "MerchantRefund",
    "kind": "LinkedField",
    "name": "refundMerchantSale",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantTransfer",
        "kind": "LinkedField",
        "name": "transfer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RefundMerchantSaleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RefundMerchantSaleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fca60aa61ba482a566e1ac65fe6e8e46",
    "id": null,
    "metadata": {},
    "name": "RefundMerchantSaleMutation",
    "operationKind": "mutation",
    "text": "mutation RefundMerchantSaleMutation(\n  $transferId: ID!\n) {\n  refundMerchantSale(transferId: $transferId) {\n    transfer {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '553effeaedf6f7da07dca62bd4619bd1';
export default node;
